module.exports = "/fonts/vendor/@fontsource/roboto/files/roboto-vietnamese-900-normal.woff2?54e7959316ff4eae1f4c428c91ffc57e";